import React, { useEffect, useState } from 'react';
import './GreetingScreen.css';

const GreetingScreen = ({ onFinish }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer1 = setTimeout(() => setVisible(false), 2000); // Show for 2s
    const timer2 = setTimeout(() => onFinish(), 2600); // Remove after fade out
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onFinish]);

  return (
    <div className={`greeting-screen${visible ? ' visible' : ' hidden'}`}>
      <div className="greeting-content">
        <div className="greeting-svg-animation">
          <svg width="120" height="40" viewBox="0 0 120 40">
            <circle className="circle c1" cx="20" cy="20" r="10" />
            <circle className="circle c2" cx="60" cy="20" r="10" />
            <circle className="circle c3" cx="100" cy="20" r="10" />
          </svg>
        </div>
        <h1>Добро пожаловать в интерактивную систему анализа медицинских процессов</h1>
      </div>
    </div>
  );
};

export default GreetingScreen; 